export default __webpack_public_path__ + "static/media/fees.baf9a5c5.svg";